/**
 * @warn when we need to use Tooltips in the Drawer, use PopperProps={{ disablePortal: true }}
 * as prop to avoid issues with zIndex
 *
 * let the drawer overlap the external html(ie: chrome extension, intercom banner)
 * https://www.digitalocean.com/community/tutorials/css-z-index
 * The maximum range is 2147483647.
 * keep one less number to handle zindex hierarchy between components
 */
export const DRAWER_Z_INDEX = 2147483646;
